module.exports = __webpack_public_path__ + "img/undraw_identation.68ed5bf1.svg";